module.exports = __webpack_public_path__ + "static/media/papegøye.1b9a00a5.m4a";